var modules_9ece3fb3 = {"icon":"CardTitle_module_icon__35018345","subtitle":"CardTitle_module_subtitle__35018345"};
import "../../../../assets/esm/components/OfferCard/components/CardTitle/CardTitle~rLeNiFMh.css";

export { modules_9ece3fb3 as default };
//# sourceMappingURL=CardTitle.module.scss.js.map
